/**
 * Mood nested mega: L2 rail → optional L3 rail → content panels.
 * Per-L2 mixed depth: dynamically shows/hides L3 column based on active L2.
 * Root element: [data-mega-nested-root] on the inner .hdt-mega-nested-wrap div.
 */
(function () {
  if (window.__megaNestedInit) return;
  window.__megaNestedInit = true;

  function activateL3(root, pair) {
    if (!pair) return;
    var l2Owner = pair.split('-')[0];

    root.querySelectorAll('.hdt-mega-nested__l3-wrap.is-active [data-mega-nested-l3]').forEach(function (btn) {
      btn.classList.toggle('is-active', btn.getAttribute('data-mega-nested-l3') === pair);
    });

    root.querySelectorAll('.hdt-mega-nested__content-panel').forEach(function (panel) {
      if (panel.classList.contains('hdt-mega-nested__content-panel--flat')) return;
      if (panel.getAttribute('data-l2-owner') !== l2Owner) return;
      panel.classList.toggle('is-active', panel.getAttribute('data-content-id') === pair);
    });
  }

  function activateL2(root, idx) {
    var idxStr = String(idx);

    root.querySelectorAll('[data-mega-nested-l2]').forEach(function (btn) {
      btn.classList.toggle('is-active', btn.getAttribute('data-mega-nested-l2') === idxStr);
    });

    var activeBtn = root.querySelector('[data-mega-nested-l2="' + idxStr + '"]');
    var hasDepth = activeBtn && activeBtn.getAttribute('data-l2-has-depth') === 'true';

    root.classList.toggle('hdt-mega-nested-wrap--l3-hidden', !hasDepth);

    root.querySelectorAll('.hdt-mega-nested__content-panel').forEach(function (p) {
      p.classList.remove('is-active');
    });

    if (hasDepth) {
      root.querySelectorAll('.hdt-mega-nested__l3-wrap').forEach(function (wrap) {
        wrap.classList.toggle('is-active', wrap.getAttribute('data-l2-panel') === idxStr);
      });

      var activeWrap = root.querySelector('.hdt-mega-nested__l3-wrap[data-l2-panel="' + idxStr + '"]');
      if (activeWrap) {
        var firstL3 = activeWrap.querySelector('[data-mega-nested-l3]');
        if (firstL3) {
          activateL3(root, firstL3.getAttribute('data-mega-nested-l3'));
        }
      }
    } else {
      root.querySelectorAll('.hdt-mega-nested__l3-wrap').forEach(function (w) {
        w.classList.remove('is-active');
      });

      var flatPanel = root.querySelector('[data-content-id="flat-' + idxStr + '"]');
      if (flatPanel) flatPanel.classList.add('is-active');
    }
  }

  function bindRoot(root) {
    if (!root || root.dataset.megaNestedBound === '1') return;
    root.dataset.megaNestedBound = '1';

    root.addEventListener('mouseenter', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var l2 = t.closest('[data-mega-nested-l2]');
      if (l2 && root.contains(l2)) {
        activateL2(root, l2.getAttribute('data-mega-nested-l2'));
        return;
      }
      var l3 = t.closest('[data-mega-nested-l3]');
      if (l3 && root.contains(l3)) {
        activateL3(root, l3.getAttribute('data-mega-nested-l3'));
      }
    }, true);

    root.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var l2 = t.closest('[data-mega-nested-l2]');
      if (l2 && root.contains(l2)) {
        e.preventDefault();
        activateL2(root, l2.getAttribute('data-mega-nested-l2'));
        return;
      }
      var l3 = t.closest('[data-mega-nested-l3]');
      if (l3 && root.contains(l3)) {
        e.preventDefault();
        activateL3(root, l3.getAttribute('data-mega-nested-l3'));
      }
    });
  }

  function scan(container) {
    (container || document).querySelectorAll('[data-mega-nested-root]').forEach(bindRoot);
  }

  scan(document);

  document.addEventListener('DOMContentLoaded', function () {
    scan(document);
  });

  document.addEventListener('shopify:section:load', function (ev) {
    if (ev.target) scan(ev.target);
  });

  document.addEventListener('lazyhtml:added', function (ev) {
    if (ev.target) scan(ev.target);
    scan(document);
  });
})();
